import LogService from '../../services/logService';
import ApiService from '../../services/apiService';

const logService = new LogService();
const apiService = new ApiService(logService);
export default {
    connectParams: {
        rewardsKey: '',
        callbackUrl: ''
    },
    gaTracker: {
        analyticsId: '',
        tagManagerId: ''
    },
    logService: logService,
    apiService: apiService
};


// WEBPACK FOOTER //
// ./src/modules/configuration/initialState.js